<script setup lang="ts">
import { useAuthStore } from '@stores/useAuthStore';

const { isImpersonated } = useAuthStore();
</script>

<template>
  <div
    class="search-map bg-gray-lighter"
    :class="{ impersonated: isImpersonated }"
  >
    <div
      :class="[
        'search-map__container',
        'sticky top-0'
      ]"
    >
      <div
        :class="[
          'h-full',
          'hidden lg:flex',
          'items-center justify-center'
        ]"
      >
        @todo Map desktop (Google Map)
      </div>
    </div>

    <div class="hidden">
      @todo Map mobile
    </div>
  </div>
</template>

<style scoped lang="scss">
@use '@styles/variables' as *;
@use '@styles/mixins' as *;

$searchMapMarginTop: toRem(20);

.search-map {
  height: 100%;
  right: 0;
  position: fixed;
  width: 100%;
  z-index: 1;

  &__container {
    display: block;
    flex-grow: 1;
    height: 100vh;
    z-index: 4;
  }

  @media screen and (min-width: $breakTablet) {
    top: calc(toRem($headerSize) + ($searchMapMarginTop / 2));
    min-width: toRem(280);
    bottom: 0;
    width: auto;
    display: block;
    flex-grow: 1;
    position: sticky;
    box-sizing: border-box;

    &__container {
      height: calc(100vh - (toRem($headerSize) + #{$searchMapMarginTop}));
      border-radius: toRem(16);
      overflow: hidden;
    }
  }
}
</style>
